<template>
  <v-dialog v-model="myValue" persistent max-width="760">
    <v-card>
      <v-card-title class="headline">流程信息</v-card-title>
      <v-card-text>
        <v-row
          style="margin-top: 50px"
          justify="center"
          no-gutters
          class="px-5"
          v-if="step.length"
        >
          <v-col cols="12" class="text-subtitle-1">
            <v-stepper alt-labels>
              <v-stepper-header>
                <template v-for="(item, index) of step">
                  <v-stepper-step
                    :step="item.step"
                    :complete="item.complete"
                    :key="index"
                  >
                    <v-row justify="center">
                      <span class="text-center">{{ item.title }}</span>
                      <small class="pt-4 text-center">{{ item.time }}</small>
                    </v-row>
                  </v-stepper-step>
                  <v-divider v-if="index < 2" :key="index"></v-divider>
                </template>
              </v-stepper-header>
            </v-stepper>
          </v-col>
        </v-row>
        <template v-if="showAddressStatus.includes(processData.status)">
          <v-row
            justify="start"
            no-gutters
            style="margin-top: 50px"
            class="px-5"
          >
            <v-col cols="auto" class="title font-weight-bold text--black"
              >回收地址</v-col
            >
          </v-row>
          <v-row
            justify="center"
            no-gutters
            class="px-5"
            style="margin-top: 20px"
          >
            <v-col cols="auto" class="text-subtitle-1">
              <table
                style="
                  border-collapse: collapse;
                  cellspacing: 0;
                  cellpadding: 0;
                "
              >
                <tbody>
                  <tr>
                    <td class="pa-4" :style="tdl">收件人</td>
                    <td class="pa-4" :style="tdr">{{ processData.recever }}</td>
                  </tr>
                  <tr>
                    <td class="pa-4" :style="tdl">联系电话</td>
                    <td class="pa-4" :style="tdr">
                      {{ processData.telephone }}
                    </td>
                  </tr>
                  <tr>
                    <td class="pa-4" :style="tdl">联系地址</td>
                    <td class="pa-4" :style="tdr">{{ processData.address }}</td>
                  </tr>
                </tbody>
              </table>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="darken-1" @click="myValue = false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { asgLtcHandleResult } from "@/plugins/api";
import { asg } from "@/plugins/chart";

export default {
  components: {},
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getData() {
      const params = {
        projectNo: this.myItem.projectcode,
      };
      asgLtcHandleResult(params).then(({ data }) => {
        this.processData = data;
      });
    },
  },
  data() {
    return {
      asg,
      tdr: {
        border: "1px solid #000000",
        width: "200px",
        "box-sizing": "border-box",
      },
      processData: {}, //流程数据
      showAddressStatus: ["1"], //可以展示回收地址的状态
    };
  },
  computed: {
    tdl() {
      return {
        ...this.tdr,
        "background-color": "#fafafa",
      };
    },
    myItem() {
      return this.item;
    },
    myValue: {
      get() {
        if (this.value) {
          this.getData();
        }
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    step() {
      if (this.processData.status === this.asg.sampleDict.recovering) {
        //回收中
        return [
          {
            step: "1",
            complete: true,
            title: "申请回收",
            time: this.processData.applydate,
          },
          {
            step: "2",
            complete: true,
            title: "回收中",
            time: "",
          },
          {
            step: "3",
            complete: false,
            title: "回收完成",
            time: this.processData.finishdate,
          },
        ];
      } else if (this.processData.status === this.asg.sampleDict.recovered) {
        //回收完成
        return [
          {
            step: "1",
            complete: true,
            title: "申请回收",
            time: this.processData.applydate,
          },
          {
            step: "2",
            complete: true,
            title: "回收中",
            time: "",
          },
          {
            step: "3",
            complete: true,
            title: "回收完成",
            time: this.processData.finishdate,
          },
        ];
      } else if (this.processData.status === this.asg.sampleDict.destroying) {
        //销毁中
        return [
          {
            step: "1",
            complete: true,
            title: "申请销毁",
            time: this.processData.applydate,
          },
          {
            step: "2",
            complete: true,
            title: "销毁中",
            time: "",
          },
          {
            step: "3",
            complete: false,
            title: "销毁完成",
            time: this.processData.finishdate,
          },
        ];
      } else if (this.processData.status === this.asg.sampleDict.destroyed) {
        //销毁完成
        return [
          {
            step: "1",
            complete: true,
            title: "申请销毁",
            time: this.processData.applydate,
          },
          {
            step: "2",
            complete: true,
            title: "销毁中",
            time: "",
          },
          {
            step: "3",
            complete: true,
            title: "销毁完成",
            time: this.processData.finishdate,
          },
        ];
      } else {
        return [];
      }
    },
  },
  created() {},
};
</script>
